<template>
  <el-dialog :visible="visible"
    :append-to-body="true"
    :showClose="true"
    title="Edit Tags"
    @close="close">
    <el-form :model="tagsCopy" v-if="filters && isShow">
      <div class="mx-24 mt-16">
        <el-row
          :gutter="16"
          class="mt-8"
        >
          <el-col :span="12">
            <el-form-item prop="car_orientation">
              <el-select
                :label="filters.header_filters[0].item_label"
                placeholder=''
                filterable
                :value="tagsCopy.car_orientation"
                @change="changeTagHandler($event, 'car_orientation')"
              >
                <el-option
                  v-for="option in filters.header_filters[0].filter_values"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="car_number">
              <!-- <el-select
                :label="filters.left_filters[0].item_label"
                placeholder=''
                filterable
                :value="tagsCopy.car_number"
                @change="changeTagHandler($event, 'car_number')"
              >
                <el-option
                  v-for="option in filters.left_filters[0].filter_values"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value"
                />
              </el-select> -->
              <el-input
                :label="filters.left_filters[0].item_label"
                placeholder=''
                :value="tagsCopy.car_number"
                @change="changeTagHandler($event, 'car_number')"
                />
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item prop="car_model">
              <el-select
                :label="filters.left_filters[2].item_label"
                placeholder=''
                filterable
                :value="tagsCopy.car_model"
                @change="changeTagHandler($event, 'car_model')"
              >
                <el-option
                  v-for="option in filters.left_filters[2].filter_values"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <el-divider/>
    </el-form>
    <el-spinner v-else color="white"/>
    <div class="dialog-footer-wrapper pt-8">
      <el-button @click="submit">Submit</el-button>
      <el-button @click="close">Cancel</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getRaceImagesFilters } from '../../api/raceimages'

export default {
  name: 'EditTagsDialog',
  props: {
    tags: {
      type: Object,
      required: true
    },
    visible: {
      type: Boolean,
      required: true
    },
    raceId: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      filters: null,
      newTags: {},
      tagsCopy: {},
      isShow: true
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    submit() {
      this.$emit('submit', this.newTags)
    },
    changeTagHandler(event, tagKey) {
      if (this.tags[tagKey] !== event && event) {
        this.newTags[tagKey] = event
        this.tagsCopy[tagKey] = event
        this.isShow = false
        this.$nextTick(() => this.isShow = true)
      }
    },
  },
  watch: {
    tags() {
      for (let key in this.tags) {
        this.tagsCopy[key] = this.tags[key]
      }
    }
  },
  mounted() {
    getRaceImagesFilters(this.raceId, {...this.selectedFilters})
      .then(res => {
        this.filters = res.data.filter
        return res
      })
  }
}
</script>

<style lang="scss" scoped>
.dialog-input-wrapper {
  padding: 16px;
}
.dialog-footer-wrapper {
  padding: 0 16px 16px 16px;
}
</style>
